import React from 'react';
import { renderHelpTextWithIcons } from './helpIconTokens';

/**
 * Render augment help copy with optional short tagline + long body.
 * Used by pick-page tooltips, clash sheet, and About (via class overrides).
 */
function AugmentHelpDescription({
  tagline,
  desc,
  className = 'augment-help-popover__desc',
  taglineClassName = 'augment-help-popover__tagline',
  paragraphClassName = 'augment-help-popover__paragraph'
}) {
  const body = desc || tagline || '';
  const lead = tagline && desc && tagline !== desc ? tagline : null;
  const paragraphs = String(body)
    .split('\n\n')
    .map((part) => part.trim())
    .filter(Boolean);

  if (paragraphs.length === 0) return null;

  return (
    <div className={className}>
      {lead ? <p className={taglineClassName}>{lead}</p> : null}
      {paragraphs.map((paragraph) => (
        <p key={paragraph} className={paragraphClassName}>
          {renderHelpTextWithIcons(paragraph)}
        </p>
      ))}
    </div>
  );
}

export default AugmentHelpDescription;
